import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    presidentCard: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 1,
        width: "100%"
    },
    photoButtonsContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    dialogPhotoBox: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        alignSelf: "center",
        aspectRatio: 3 / 4,
        overflow: "hidden",
        borderWidth: 1,
        width: 140,
        ...webStyle({
            cursor: "pointer"
        })
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 240
    },
    presidentPhotoBox: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        aspectRatio: 1,
        borderWidth: 1,
        height: 52,
        width: 52
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 200
    },
    presidentDetails: {
        justifyContent: "center"
    },
    photoPlaceholderContent: {
        alignItems: "center"
    },
    dialogContentContainer: {
        alignItems: "stretch",
        width: 440
    },
    dialogForm: {
        alignItems: "stretch",
        width: "100%"
    },
    actionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    presidentInfo: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    orderBadge: {
        paddingVertical: 2
    },
    presidentPhoto: {
        height: "100%",
        width: "100%"
    },
    photoInput: {
        display: "none"
    },
    listContainer: {
        width: "100%"
    },
    container: {
        width: "100%"
    }
});
export default stylesheet;
